export default "__VITE_ASSET__Da1e7QEn__"